import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import { getEntityChangementMessage } from '@infrastructure/entityChangement/utils'
import queryClient from '@infrastructure/reactQuery/queryClient'
import toast from '@infrastructure/toast/toast'

import markerCategoryRQKeys from '../reactQuery/markerCategoryRQKeys'

export default createEntityChangementConfig2({
  entity: 'marker_category',
  config: [
    {
      changements: ['created', 'updated', 'deleted'],
      listener: ({ name, type }) => {
        toast.info({
          title: getEntityChangementMessage(name, type)
        })
        const key = markerCategoryRQKeys.lists()
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['updated'],
      listener: ({ meta: { id } }) => {
        const key = markerCategoryRQKeys.detail(id)
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['deleted'],
      listener: ({ meta: { id } }) => {
        const key = markerCategoryRQKeys.detail(id)
        queryClient.removeQueries(key)
      }
    }
  ]
})
